import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center px-4 pt-20 pb-16 overflow-hidden" data-id="element-36">
      {/* Background — simple radial gradient, no blur */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(8,145,178,0.12) 0%, transparent 70%)'
    }} data-id="element-37" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-38">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4
      }} className="inline-block mb-6 px-4 py-1.5 rounded-full border border-cyan-500/30 bg-cyan-500/10 text-cyan-300 text-sm font-medium tracking-wide uppercase" data-id="element-39">
          Protocolo Fisiológico Avanzado
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="font-heading text-4xl sm:text-5xl md:text-6xl text-white leading-[1.15] mb-8" data-id="element-40">
          Cómo Desplomar tus Niveles de{' '}
          <span className="text-amber-400" data-id="element-41">Cortisol</span> en{' '}
          <span className="text-amber-400" data-id="element-42">7 Minutos</span> y Despertar con
          Claridad Mental Total — <span className="text-slate-400" data-id="element-43">Sin</span>{' '}
          Melatonina, <span className="text-slate-400" data-id="element-44">Sin</span> Apps de
          Meditación y <span className="text-slate-400" data-id="element-45">Sin</span> Rutinas
          Agotadoras.
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} className="text-lg sm:text-xl text-slate-300 mb-10 leading-relaxed max-w-2xl mx-auto font-body" data-id="element-46">
          Accede al Protocolo Fisiológico que los Biohackers de Élite usan para{' '}
          <span className="text-cyan-300 font-medium" data-id="element-47">'Apagar' el Cerebro</span>{' '}
          y entrar en Sueño Profundo de forma mecánica.
        </motion.p>

        {/* Product Mockup Image */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="relative mb-12 mx-auto max-w-2xl" data-id="element-48">
          <img src="https://cdn.magicpatterns.com/uploads/mPnEu9zXBtwPFBZcEcgmoq/3d_book.png" alt="Protocolo Cortisol-Zero™ — disponible en libro, tablet y móvil" loading="eager" decoding="async" className="relative z-10 w-full h-auto rounded-2xl" data-id="element-49" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.5
      }} data-id="element-50">
          <CTAButton text="Acceder al Protocolo por $6.36" onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-51" />
          <p className="mt-4 text-sm text-slate-500" data-id="element-52">
            Acceso inmediato • Lectura de 15 min
          </p>
        </motion.div>
      </div>
    </section>;
}